"use client";
import { Card } from "react-bootstrap";
import { getPaymentMethodLabel } from "../../../utils/getPaymentMethodLabel";
import { formatDate } from "../../../utils";

interface DeliveryDetailsProps {
  order: any;
}



const getOrderStatusLabel = (status?: string): string => {
  const statuses: Record<string, string> = {
    CREATED: "Creado",
    PENDING_APPROVAL: "Pendiente por aprobar",
    PAID: "Pagado",
    PROCESSING: "Procesando",
    SHIPPED: "Enviado",
    DELIVERED: "Entregado",
    CANCELLED: "Cancelado",
    PENDING_PROOF: "Pendiente de comprobante",
  };
  return status ? statuses[status] || status : "Desconocido";
};

const getDeliveryTypeLabel = (type?: string): string => {
  const types: Record<string, string> = {
    PHYSICAL: "Físico",
    DELIVERY: "A domicilio",
    STORE_PICKUP: "Recogida en tienda",
  };
  return type ? types[type] || type : "No especificado";
};

const DeliveryDetails = ({ order }: DeliveryDetailsProps) => {
  if (!order) return null;

  return (
    <Card className="bg-white border-0 rounded-3 mb-4">
      <Card.Body className="p-4">
        <h3 className="mb-3">Detalles de Entrega</h3>

        <div className="d-flex align-items-center mb-2">
          <span className="text-secondary">ID de Orden:</span>
          <span className="ms-1">{order?.id}</span>
        </div>

        <div className="d-flex align-items-center mb-2">
          <span className="text-secondary">Tipo de Entrega:</span>
          <span className="ms-1">{getDeliveryTypeLabel(order?.delivery_type)}</span>
        </div>

        <div className="d-flex align-items-center mb-2">
          <span className="text-secondary">Método de Pago:</span>
          <span className="ms-1">{getPaymentMethodLabel(order?.payment_method)}</span>
        </div>

        <div className="d-flex align-items-center mb-2">
          <span className="text-secondary">Proveedor de Pago:</span>
          <span className="ms-1">{order?.payment_provider || "No aplica"}</span>
        </div>

        <div className="d-flex align-items-center mb-2">
          <span className="text-secondary">Estado:</span>
          <span className="ms-1">{getOrderStatusLabel(order?.status)}</span>
        </div>

        <div className="d-flex align-items-center mb-2">
          <span className="text-secondary">Pagado:</span>
          <span className="ms-1">{order?.is_paid ? "Sí" : "No"}</span>
        </div>

        {order?.payment_created_at && (
          <div className="d-flex align-items-center mb-2">
            <span className="text-secondary">Fecha de pago:</span>
            <span className="ms-1">{formatDate(order?.payment_created_at)}</span>
          </div>
        ) }
        

        {order && !order.is_paid && order?.wompi_id && (
          <div className="d-flex align-items-center mb-2">
            <span className="text-secondary">Pendiente de pago:</span>
            <a
              href={`https://checkout.wompi.co/l/${order?.wompi_id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="ms-1 text-success text-decoration-underline"
            >
              Pagar ahora
            </a>
          </div>
        )}

        <div className="d-flex align-items-center mb-0">
          <span className="text-secondary">Email:</span>
          <span className="ms-1">{order?.user_id?.email || "N/A"}</span>
        </div>
      </Card.Body>
    </Card>
  );
};

export default DeliveryDetails;
